export const TRIG_FLASHCARDS = [
  {
    front: "Identity: $$\\sin^2 x + \\cos^2 x = \\, ?$$",
    back: "$$\\sin^2 x + \\cos^2 x = 1$$",
    tags: ["trig", "identity", "pythagorean"],
  },
  {
    front: "Identity: $$1 + \\tan^2 x = \\, ?$$",
    back: "$$1 + \\tan^2 x = \\sec^2 x$$",
    tags: ["trig", "identity", "pythagorean"],
  },
  {
    front: "Identity: $$1 + \\cot^2 x = \\, ?$$",
    back: "$$1 + \\cot^2 x = \\csc^2 x$$",
    tags: ["trig", "identity", "pythagorean"],
  },
  {
    front: "Double angle: $$\\sin(2x) = \\, ?$$",
    back: "$$\\sin(2x) = 2\\sin x \\cos x$$",
    tags: ["trig", "identity", "double-angle"],
  },
  {
    front: "Double angle: $$\\cos(2x) = \\, ?$$",
    back: "$$\\cos(2x) = \\cos^2 x - \\sin^2 x = 1 - 2\\sin^2 x = 2\\cos^2 x - 1$$",
    tags: ["trig", "identity", "double-angle"],
  },
  {
    front: "Power reduction: $$\\sin^2 x = \\, ?$$",
    back: "$$\\sin^2 x = \\tfrac{1 - \\cos(2x)}{2}$$",
    tags: ["trig", "identity", "power-reduction"],
  },
  {
    front: "Power reduction: $$\\cos^2 x = \\, ?$$",
    back: "$$\\cos^2 x = \\tfrac{1 + \\cos(2x)}{2}$$",
    tags: ["trig", "identity", "power-reduction"],
  },
  {
    front: "Product-to-sum: $$\\sin u \\sin v = \\, ?$$",
    back: "$$\\sin u \\sin v = \\tfrac{1}{2}[\\cos(u-v) - \\cos(u+v)]$$",
    tags: ["trig", "identity", "product-to-sum"],
  },
  {
    front: "Product-to-sum: $$\\cos u \\cos v = \\, ?$$",
    back: "$$\\cos u \\cos v = \\tfrac{1}{2}[\\cos(u-v) + \\cos(u+v)]$$",
    tags: ["trig", "identity", "product-to-sum"],
  },
  {
    front: "Product-to-sum: $$\\sin u \\cos v = \\, ?$$",
    back: "$$\\sin u \\cos v = \\tfrac{1}{2}[\\sin(u+v) + \\sin(u-v)]$$",
    tags: ["trig", "identity", "product-to-sum"],
  },
  {
    front: "Basic integral: $$\\int \\sin x\\,dx = \\, ?$$",
    back: "$$\\int \\sin x\\,dx = -\\cos x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Basic integral: $$\\int \\cos x\\,dx = \\, ?$$",
    back: "$$\\int \\cos x\\,dx = \\sin x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Basic integral: $$\\int \\sec^2 x\\,dx = \\, ?$$",
    back: "$$\\int \\sec^2 x\\,dx = \\tan x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Basic integral: $$\\int \\csc^2 x\\,dx = \\, ?$$",
    back: "$$\\int \\csc^2 x\\,dx = -\\cot x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Basic integral: $$\\int \\sec x \\tan x\\,dx = \\, ?$$",
    back: "$$\\int \\sec x \\tan x\\,dx = \\sec x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Basic integral: $$\\int \\csc x \\cot x\\,dx = \\, ?$$",
    back: "$$\\int \\csc x \\cot x\\,dx = -\\csc x + C$$",
    tags: ["trig", "integral", "basic"],
  },
  {
    front: "Log-form integrals: $$\\int \\tan x\\,dx = \\, ?$$",
    back: "$$\\int \\tan x\\,dx = -\\ln|\\cos x| + C$$",
    tags: ["trig", "integral", "log"],
  },
  {
    front: "Log-form integrals: $$\\int \\cot x\\,dx = \\, ?$$",
    back: "$$\\int \\cot x\\,dx = \\ln|\\sin x| + C$$",
    tags: ["trig", "integral", "log"],
  },
  {
    front: "Log-form integrals: $$\\int \\sec x\\,dx = \\, ?$$",
    back: "$$\\int \\sec x\\,dx = \\ln|\\sec x + \\tan x| + C$$",
    tags: ["trig", "integral", "log"],
  },
  {
    front: "Log-form integrals: $$\\int \\csc x\\,dx = \\, ?$$",
    back: "$$\\int \\csc x\\,dx = -\\ln|\\csc x + \\cot x| + C$$",
    tags: ["trig", "integral", "log"],
  },
  {
    front: "Trig substitution pattern: $$\\sqrt{a^2 - x^2}$$",
    back: "$$x = a\\sin\\theta,\\quad dx = a\\cos\\theta\\,d\\theta$$",
    tags: ["trig", "substitution", "sqrt(a^2 - x^2)"],
  },
  {
    front: "Trig substitution pattern: $$\\sqrt{a^2 + x^2}$$",
    back: "$$x = a\\tan\\theta,\\quad dx = a\\sec^2\\theta\\,d\\theta$$",
    tags: ["trig", "substitution", "sqrt(a^2 + x^2)"],
  },
  {
    front: "Trig substitution pattern: $$\\sqrt{x^2 - a^2}$$",
    back: "$$x = a\\sec\\theta,\\quad dx = a\\sec\\theta\\tan\\theta\\,d\\theta$$",
    tags: ["trig", "substitution", "sqrt(x^2 - a^2)"],
  },
  {
    front: "Integral result: $$\\int \\frac{dx}{\\sqrt{a^2 - x^2}} = \\, ?$$",
    back: "$$\\int \\frac{dx}{\\sqrt{a^2 - x^2}} = \\arcsin\\!\\left(\\tfrac{x}{a}\\right) + C$$",
    tags: ["trig", "integral", "substitution"],
  },
  {
    front: "Integral result: $$\\int \\frac{dx}{a^2 + x^2} = \\, ?$$",
    back: "$$\\int \\frac{dx}{a^2 + x^2} = \\tfrac{1}{a}\\arctan\\!\\left(\\tfrac{x}{a}\\right) + C$$",
    tags: ["trig", "integral", "substitution"],
  },
  {
    front: "Integral result: $$\\int \\frac{dx}{x\\sqrt{x^2 - a^2}} = \\, ?$$",
    back: "$$\\int \\frac{dx}{x\\sqrt{x^2 - a^2}} = \\tfrac{1}{a}\\operatorname{arcsec}\\!\\left(\\tfrac{|x|}{a}\\right) + C$$",
    tags: ["trig", "integral", "substitution"],
  },
  {
    front: "Strategy: $$\\int \\sin^m x\\,\\cos^n x\\,dx$$ (one power odd)",
    back: "If one power is odd, peel one factor and convert the other with $$\\sin^2 x = 1-\\cos^2 x$$ or $$\\cos^2 x = 1-\\sin^2 x$$, then substitute.",
    tags: ["trig", "integral", "strategy"],
  },
  {
    front: "Strategy: $$\\int \\sin^m x\\,\\cos^n x\\,dx$$ (both even)",
    back: "If both are even, use power-reduction: $$\\sin^2 x = \\tfrac{1-\\cos 2x}{2},\\; \\cos^2 x = \\tfrac{1+\\cos 2x}{2}$$ and repeat until integrable.",
    tags: ["trig", "integral", "strategy"],
  },
  {
    front: "Strategy: $$\\int \\sec^m x\\,\\tan^n x\\,dx$$",
    back: "If $$m$$ is even, save $$\\sec^2 x\\,dx$$ and convert the rest with $$1+\\tan^2 x=\\sec^2 x$$. If $$n$$ is odd, save $$\\sec x\\tan x\\,dx$$ and convert with $$\\tan^2 x=\\sec^2 x-1$$.",
    tags: ["trig", "integral", "strategy"],
  },
  {
    front: "Strategy: $$\\int \\csc^m x\\,\\cot^n x\\,dx$$",
    back: "If $$m$$ is even, save $$\\csc^2 x\\,dx$$ and use $$1+\\cot^2 x=\\csc^2 x$$. If $$n$$ is odd, save $$\\csc x\\cot x\\,dx$$ and use $$\\cot^2 x=\\csc^2 x-1$$.",
    tags: ["trig", "integral", "strategy"],
  },
];

export default TRIG_FLASHCARDS;
